import React, { useCallback } from "react";

import { Card } from "2g-cards";
import Buttons from "2g-buttons";
import { Icons } from "2g-icons";

import { PATHS } from "b2b/constants";
import { useRedirect } from "b2b/hooks";
import useMessages from "./i18n/useMessages";

function CardRedirect() {
  const messages = useMessages();
  const redirect = useRedirect();
  const redirectToProvozniInformace = useCallback(() => {
    redirect(PATHS.PROVOZNI_INFORMACE.LIST);
  }, [redirect]);
  return (
    <Card onClick={redirectToProvozniInformace}>
      <Buttons.Primary rounded inverse>
        <Icons.ArrowDouble />
      </Buttons.Primary>
      <div className="r2g-CardRedirect-label">{messages.cardNext()}</div>
    </Card>
  );
}

export default React.memo(CardRedirect);
